var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconPinterest = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 14 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.424 0C2.489 0 0 3.719 0 6.819c0 1.877.677 3.548 2.127 4.17.238.103.451.004.521-.273.048-.192.16-.675.212-.877.07-.274.043-.37-.149-.608-.418-.52-.685-1.19-.685-2.14 0-2.759 1.964-5.228 5.114-5.228 2.79 0 4.321 1.791 4.321 4.182 0 3.148-1.325 5.803-3.293 5.803-1.086 0-1.9-.944-1.64-2.103.312-1.382.917-2.875.917-3.874 0-.894-.456-1.638-1.4-1.638-1.112 0-2.004 1.208-2.004 2.825 0 1.03.332 1.727.332 1.727l-1.337 5.947c-.396 1.766-.06 3.93-.031 4.148.016.129.175.16.247.063.103-.141 1.426-1.858 1.875-3.573.128-.486.731-3 .731-3 .362.723 1.416 1.36 2.537 1.36 3.34 0 5.605-3.2 5.605-7.48C13.998 3.014 11.388 0 7.424 0Z",
  fill: "currentColor"
})));

export default SvgIconPinterest;